import { useSelector } from 'react-redux'
import { RootState } from 'cityads-v3/types/reducer'

export function useFilterLists() {
  return {
    regionList: useSelector((state: RootState) => state.offers.regionsById),
    categoryList: useSelector((state: RootState) => state.offers.coupon_categoriesById),
    offerList: useSelector((state: RootState) => state.offers.couponOffersById),
    promoActionTypeList: useSelector((state: RootState) => state.offers.promoActionTypesById),
    promoCouponStatusList: useSelector((state: RootState) => state.offers.promoCouponStatusesById),
    languageList: useSelector((state: RootState) => state.language.sadukaLanguagesById),
    couponSectorList: useSelector((state: RootState) => state.couponSectors.couponSectorsById),
    couponScopeList: useSelector((state: RootState) => state.offers.promoCouponScopesById),
  }
}
